import ExactFundSelector from './ExactFundSelector';

export default ExactFundSelector;
